import React from 'react';
import { AutoPayScreen } from '@/screens/payments/autopay-screen';
import { createStackNavigator } from '@react-navigation/stack';
import { PAYMENT_ROUTES } from './routes';
import { PaymentMethodSelectScreen } from '@/screens/payments/payment-method-select-screen';
import { PaymentsScreen } from '@/screens/payments/payments-screen';
import { PaymentsStackParams } from './types';
import { PaymentsStatus } from '@/enums';
import { SplitPaymentsScreen } from '@/screens/payments/split-payments-screen';
import { useDefaultAppTabScreenOptions } from '@/hooks/use-default-app-tab-screen-options';
import { useLayoutContext } from '@/contexts/layout-context';
import { useUserContext } from '@/contexts/user-context';

const Stack = createStackNavigator<PaymentsStackParams>();

export const PaymentsStack: React.FC = () => {
  const screenOptions = useDefaultAppTabScreenOptions();
  const { isSmallLayout } = useLayoutContext();
  const {
    selectedRestaurantRelationship: { showPaymentsTab, supplierPaymentsStatus },
  } = useUserContext();

  return (
    <Stack.Navigator
      initialRouteName={PAYMENT_ROUTES.Base}
      screenOptions={screenOptions}
    >
      <Stack.Screen
        component={isSmallLayout ? PaymentsScreen : SplitPaymentsScreen}
        name={PAYMENT_ROUTES.Base}
      />
      {supplierPaymentsStatus === PaymentsStatus.Enabled && showPaymentsTab ? (
        <Stack.Screen
          component={PaymentMethodSelectScreen}
          name={PAYMENT_ROUTES.PaymentMethod}
        />
      ) : null}
      <Stack.Screen component={AutoPayScreen} name={PAYMENT_ROUTES.AutoPay} />
    </Stack.Navigator>
  );
};
